"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = require("react-select");
var _selectConstants = require("../selectConstants");
var _SelectAllContext = require("./SelectAllContext");
var _VirtualizedMenuList = require("./VirtualizedMenuList");
const MenuList = props => {
  const {
    options = [],
    optionHeight = _selectConstants.DEFAULT_ITEM_HEIGHT,
    components
  } = props.selectProps;
  const selectAllEnabled = (0, _react.useContext)(_SelectAllContext.SelectAllContext).enabled;
  const getOptionHeight = (0, _react.useCallback)(index => {
    if (selectAllEnabled && index === 0) {
      // TODO move optionHeight to the LayoutContext.
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return optionHeight + 24; // 24 is the height of the Separator.
    } else {
      // TODO move optionHeight to the LayoutContext.
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return optionHeight;
    }
  }, [selectAllEnabled, optionHeight]);
  if (options.length > _selectConstants.MAX_OPTIONS_UNTIL_VIRTUALIZATION) {
    const VirtualizedMenuListComponent = components.VirtualizedMenuList || _VirtualizedMenuList.VirtualizedMenuList;
    return /*#__PURE__*/_react.default.createElement(VirtualizedMenuListComponent, {
      maxHeight: props.maxHeight,
      getOptionHeight: getOptionHeight,
      innerRef: props.innerRef
    }, props.children);
  }
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.MenuList, props, props.children);
};
exports.MenuList = MenuList;
//# sourceMappingURL=MenuList.js.map